export enum StepperAutomatedPages {
    CriteriaGuided = 'criteria_guided',
    DetailsGuided = 'details_guided',
    costInfoGuided = 'cost_info',
    ReviewGuided = 'review_guided',
    ResultsGuided = 'results_guided'
  }